import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { EnvironmentService } from '../environment/environment.service';
import { FeatureFlag } from './feature-flag';

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService {
    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    public getFeatureFlags(): Promise<FeatureFlag[]> {
        return lastValueFrom(this.http.get(this.environmentService.apiUrl + '/featureflags')) as Promise<FeatureFlag[]>;
    }
}
